import { render, staticRenderFns } from "./conversionred-detail.vue?vue&type=template&id=4821735a&scoped=true&"
import script from "./conversionred-detail.vue?vue&type=script&lang=js&"
export * from "./conversionred-detail.vue?vue&type=script&lang=js&"
import style0 from "./conversionred-detail.vue?vue&type=style&index=0&id=4821735a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821735a",
  null
  
)

export default component.exports